import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BadgeComponent, MarkdownDirective } from '@ftr/foundation'
import { LinkGridItemComponent } from './link-grid-item.component'
import { LinkGridComponent } from './link-grid.component'

@NgModule({
  imports: [BadgeComponent, CommonModule, MarkdownDirective],
  declarations: [LinkGridComponent, LinkGridItemComponent],
  exports: [LinkGridComponent, LinkGridItemComponent],
})
export class LinkGridModule {}
